import request from '../request'

/**
 * 协同系统-项目执行-会签 相关接口
 */

/**
 * 新增会签
 * @param {Object} data - 会签数据
 */
export function addCountersign(data) {
    return request({
        url: '/project-service/cosys/countersign/add',
        method: 'POST',
        data
    })
}

/**
 * 根据会签编码查询会签详情
 * @param {string|number} signCode - 会签编码
 */
export function fetchCountersignDetailBySignCode(signCode) {
    return request({
        url: `/project-service/cosys/countersign/detailBySignCode/${signCode}`,
        method: 'GET'
    })
}

/**
 * 根据会签ID列表获取设计成果文件列表
 * @param {Object} data - 会签ID列表参数
 */
export function getDesignResultFiles(data) {
    return request({
        url: '/project-service/cosys/countersign/getDesignResultFiles',
        method: 'POST',
        data
    })
}

/**
 * 获取会签列表
 * @param {Object} params - 查询参数
 */
export function fetchCountersignList(params) {
    return request({
        url: '/project-service/cosys/countersign/list',
        method: 'GET',
        params
    })
}

/**
 * 根据文件id返回所有page
 * @param {string|number} fileId - 文件ID
 */
export function listPagesByFileId(fileId) {
    return request({
        url: `/project-service/cosys/countersign/listPages/${fileId}`,
        method: 'GET'
    })
}

/**
 * 重新发起会签
 * @param {Object} data - 会签数据
 */
export function resubmitCountersign(data) {
    return request({
        url: '/project-service/cosys/countersign/resubmit',
        method: 'POST',
        data
    })
}

/**
 * 跳过会签
 * @param {Object} data - 请求参数
 */
export function skipCountersign(data) {
    return request({
        url: '/project-service/cosys/countersign/skip',
        method: 'POST',
        data
    })
}

/**
 * 修改会签（原有接口，文档无此接口保留）
 * @param {Object} data - 会签数据
 */
export function updateCountersign(data) {
    return request({
        url: '/project-service/cosys/countersign/update',
        method: 'POST',
        data
    })
}